const keys = {
  financialInstitution: {
    alternaBank: 'Alterna Bank',
    alternaSavings: 'Alterna Savings',
    bankofMontreal: 'Bank of Montreal',
    caisseAlliance: 'Caisse Alliance',
    canadianWesternBank: 'Canadian Western Bank',
    central1CreditUnion: 'Central 1 Credit Union',
    cibc: 'Canadian Imperial Bank of Commerce (CIBC)',
    desjardinsGroup: 'Desjardins Group',
    desjardinsOntarioCreditUnion: 'Desjardins Ontario Credit Union',
    equitableBank: 'Equitable Bank',
    hsbcBank: 'HSBC Bank of Canada',
    laurentianBank: 'Laurentian Bank of Canada',
    manulifeBank: 'Manulife Bank of Canada',
    meridianCreditUnion: 'Meridian Credit Union',
    motusbank: 'Motusbank',
    nationalBank: 'National Bank of Canada',
    peoplesTrustBank: "People's Trust Bank",
    presidentChoiceBank: "President's choice Bank",
    royalBank: 'Royal Bank of Canada (RBC)',
    scotiabank: 'Scotiabank',
    tangerineBank: 'Tangerine',
    tdBank: 'The Toronto-Dominion Bank (TD)',
    vancityBank: 'Vancity Bank',
    wealthOneBank: 'Wealth One Bank',
    wealthsimple: 'Wealthsimple',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
